import React, { useMemo } from 'react';
import PropTypes from 'prop-types';

import Traductor from 'components/Traductor';

const ControlledAccordion = ({
    label,
    content,
    expanded,
    condition = true,
    onOpen = () => null,
}) => {
    const t = useMemo(() => new Traductor(), []);
    return (
        <>
            <div
                className={`c-accordion__header  js-accordion__title u-pl-none ${
                    expanded ? 'is-active' : ''
                }`}
                onClick={e => {
                    e.preventDefault();
                    e.stopPropagation();
                    e.nativeEvent.stopImmediatePropagation();
                    onOpen(label);
                }}
            >
                <span className="c-accordion__title-icon" />
                <h3 className="c-accordion__title">
                    <button
                        className="c-accordion__title-label  js-accordion__title-label"
                        aria-expanded={expanded}
                        type="button"
                    >
                        <span className="c-accordion__title-label-text">
                            <p className="u-h6">{label}</p>
                        </span>
                    </button>
                </h3>
            </div>
            <div
                className="c-accordion__panel  js-accordion__panel"
                aria-hidden={!expanded}
            >
                <div className="c-accordion__content">
                    {condition ? (
                        content
                    ) : (
                        <p>{t.getTraduction('DataNoAvailable')}</p>
                    )}
                </div>
            </div>
        </>
    );
};

ControlledAccordion.propTypes = {
    label: PropTypes.string.isRequired,
    content: PropTypes.oneOfType([
        PropTypes.any,
        PropTypes.elementType,
        PropTypes.arrayOf(PropTypes.elementType),
    ]),
    condition: PropTypes.any,
    expanded: PropTypes.bool,
};

export default ControlledAccordion;
